import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Logo } from "./Header";

export default function Footer() {
  return (
    <footer className="mt-24" data-testid="site-footer">
      <div className="ribbon" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div className="flex items-start gap-4">
          <Logo size="h-20 w-20" />
          <div>
            <p className="font-display text-2xl">L3's Kitchen Co.</p>
            <p className="font-script text-lg text-[var(--pink)]">and More Sweet Treats</p>
          </div>
        </div>
        <div className="space-y-2 text-white/70">
          <p className="font-display text-lg text-white">Explore</p>
          <Link to="/shop" className="block hover:text-[var(--pink)]" data-testid="footer-shop-link">Shop all treats</Link>
          <Link to="/custom-order" className="block hover:text-[var(--pink)]" data-testid="footer-custom-link">Request a custom order</Link>
          <Link to="/admin" className="block hover:text-[var(--pink)]" data-testid="footer-admin-link">Owner login</Link>
        </div>
        <div>
          <p className="font-script text-3xl text-[var(--pink)]">Thank You</p>
          <p className="mt-1 text-white/70">for supporting my small business!</p>
          <Heart className="mt-3 h-6 w-6 fill-[var(--blue)] text-[var(--blue)]" />
        </div>
      </div>
      <p className="pb-8 text-center text-xs text-white/40">© {new Date().getFullYear()} L3's Kitchen Co. and More</p>
    </footer>
  );
}
